module.exports = __webpack_public_path__ + "img/three3Green.012c1ec5.jpg";